export default function ({ url }) {
    return {
        loadingDelivery: true,
        showDeliveryInfo: false,
        showTooltip: false,
        contentDeliveryInfo: '',
        contentTooltip: '',
        init() {
            try {
                fetch(url, {
                    method: 'GET',
                    cache: 'no-store'
                })
                    .then((response) => response.json())
                    .then((data) => {
                        this.loadingDelivery = false;
                        if (data.delivery_estimation) {
                            this.showDeliveryInfo = true;
                            this.contentDeliveryInfo = data.delivery_estimation;
                        }

                        if (data.tooltip) {
                            this.showTooltip = true;
                            this.contentTooltip = data.tooltip;
                        }
                    });
            } catch (error) {
                console.error(error);
            }
        }
    };
}
